import React from 'react';
import IconButton from 'components/IconButton';
import ArrowLineLeftIcon from '@nokia-csf-uxr/ccfk-assets/ArrowLineLeftIcon';

/**
 * Single BreadcrumbBackArrow wrapper for BreadcrumbCompacts
 * All props will be provided to the wrapped IconButton component.
 */
const BreadcrumbBackArrow = props => (
  <IconButton rippleStyle={{ flexShrink: 0 }} {...props}>
    <ArrowLineLeftIcon />
  </IconButton>
);

BreadcrumbBackArrow.displayName = 'BreadcrumbBackArrow';

export default BreadcrumbBackArrow;
